import React, { useContext, useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import { Container } from '../../base/Container';
import AppToaster from '../../commonLib/AppToaster';
import { LoadingButton } from '../../commonLib/LoadingButton';
import { loadingMiniContext } from '../../commonLib/lodingMiniContext';
import { BASE_URL } from '../../initApi/apiUrls';
import { dashboardContext } from './../Global/dashboardContext'
import * as productionUnitCrud from '../../_crud/productionUnitCrud';
import { ImageUploader } from '../../commonLib/ImageUploader';

export function ProductionUnitDocument() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const [dashboardData, setDashboardData] = useContext(dashboardContext)
    const history = useHistory();
    const { id } = useParams()
    const [docs, SetDocs] = useState("")

    useEffect(() => {
        if (!dashboardData.productiondata)
            history.push("/productionunit/dashboard/" + id)
    }, []);

    const SetPhoto = (image) => {
        SetDocs(image)
    }
    const SavePhoto = () => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true);
        const formData = new FormData()
        formData.append('id', id)
        formData.append('file', docs)
        productionUnitCrud.UploadDocument(formData)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false);
                    setIsLoadingLocal(false);
                    AppToaster('Updated successfully.', 'success')
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }

            })
            .catch(error => {
                alert("image size is too large.")
                setIsLoadingMini(false);
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })

    }
    return (
        <Container title="Production Doucment" isBack="true" isProduction="true" isContact="true">

            <div className="row">
                <div className="col-md-2">
                </div>

                <div className="col-md-8">
                    <div class="form-group">
                        <div class="col-xs-12">
                            <br />
                            <label class="control-label no-padding-right"> Upload Document</label>
                            <ImageUploader Height={1200} Width={1200} initImage={dashboardData.productiondata && dashboardData.productiondata.isDocument == 1 ? (BASE_URL + "/" + dashboardData.productiondata.documentUrl) : undefined} SetImage={SetPhoto} />
                        </div>
                    </div>
                </div>
            </div>

            <div class="clearfix form-actions">
                <div class="pull-right">
                    {isLoadingLocal ?
                        <LoadingButton />
                        :
                        <button class="btn btn-info" type="submit" expand="block" onClick={SavePhoto} disabled={!docs}>
                            <i class="ace-icon fa fa-check bigger-110"></i>
                            Upload
                        </button>}
                </div>
            </div>

        </Container >
    )
}
